import logo from "@/_assets/logo.png";
import { Link } from "@/i18n/navigation";
import Image from "next/image";
import { usePathname } from "next/navigation";

function Logo() {
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  return (
    <Link
      href={"/"}
      className="relative h-[40px] w-[100px] md:h-[57px] md:w-[137px]"
    >
      <Image
        src={logo}
        fill
        alt="eSIM Card logo"
        sizes="auto"
        quality={70}
        priority
      />
    </Link>
  );
}

export default Logo;
